/* eslint-disable react/require-default-props */
import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { CircularProgress, useMediaQuery } from '@mui/material';
import ModalHeader from './ModalHeader';
import SideBarSection from './SideBarSection';
import ModalFooter from './ModalFooter';
import { FooterAction, Section } from '../../interfaces';
import './modal.css';

interface Props {
  backButton?: boolean;
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>> | (() => void);
  name: string;
  sections: Section[];
  footerActions?: FooterAction[];
  moreActions?: FooterAction[];
  isLoading?: boolean;
}

const SideBarModal = React.forwardRef<HTMLDivElement, Props>(
  (
    {
      backButton,
      modalOpen,
      setModalOpen,
      name,
      sections,
      footerActions,
      moreActions,
      isLoading,
    },
    ref,
  ) => {
    const matches = useMediaQuery('(min-width:900px)');

    const style = {
      position: 'absolute' as 'absolute',
      top: '0px',
      right: '0px',
      width: matches ? 400 : '100%',
      bgcolor: '#f9f9f9',
      boxShadow: '-5px 0px 10px rgb(0 0 0 / 10%)',
      overflowY: 'scroll',
      height: '100dvh',
    };

    const handleClose = React.useCallback(() => {
      setModalOpen(false);
    }, [setModalOpen]);

    return (
      <div>
        <Modal
          open={modalOpen}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description">
          <Box sx={style}>
            <div ref={ref} className="printable-container">
              <ModalHeader
                name={name}
                handleClose={handleClose}
                moreActions={moreActions}
                backButton={backButton}
              />
              {!isLoading
                ? sections.map(section => (
                    <SideBarSection
                      name={section.name}
                      rows={section.rows}
                      modalName={name}
                      values={section.values}
                      key={section.name}
                      buttonText={section.buttonText}
                      buttonAction={section.buttonAction}
                      noGap={section.noGap}
                    />
                  ))
                : null}

              {isLoading && (
                <Box
                  width="100%"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  py={2}>
                  <CircularProgress size={24} />
                </Box>
              )}
            </div>
            <div className="push" />
            {footerActions?.length && !isLoading ? (
              <ModalFooter footerActions={footerActions} />
            ) : null}
          </Box>
        </Modal>
      </div>
    );
  },
);

export default SideBarModal;
